<script>
import ModelShow from '../models/show';
import Row from '@/components/models/show/custom-row';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Drivers",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('drivers.singular')) }},
    resourceRoute: {default: 'drivers'},
    modelVariable: {default: 'company'},
    denyEdit: {type: Boolean, default() { return !this.$auth.hasPermissionTo('drivers.edit') }},
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || 'model']: [
            {
              key: 'key',
              label: this.$t('models.key'),
              component: Row
            }
          ]
        };
      }
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('drivers.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('drivers.plural')),
          href: "/drivers",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/drivers/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.startCase(this.$t(`${this.resourceRoute}.name`)),
        value: this.model.name,
        class: 'row',
        labelClass: 'col-sm-12 col-md-2',
        valueClass: 'col-sm-12 col-md-9',
        showColon: true,
      }, {
        key: this.lodash.startCase(this.$t(`${this.resourceRoute}.phone_number`)),
        value: this.model.phone_number,
        class: 'row',
        labelClass: 'col-sm-12 col-md-2',
        valueClass: 'col-sm-12 col-md-9',
        showColon: true,
      }, {
        key: this.lodash.startCase(this.$t(`models.description`)),
        item: this.model.description,
        value: {
          props: { item: {type: String, default: ''} },
          template: `<span v-html="item || '-'"></span>`
        },
        class: 'row',
        labelClass: 'col-sm-12 col-md-2',
        valueClass: 'col-sm-12 col-md-9',
        showColon: true,
      }]
    }
  },
  methods: {
    delete() {
      return this.$axios.delete(`/drivers/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/drivers/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
          .finally(() => this.loading = false)
    }
  }
}
</script>
